import classNames from "classnames";
import { FormattedMessage } from "react-intl";

import { ExtendedText } from "../../../features/emoji";
import { Link } from "../../Link";
import { ConditionalWrapper } from "../ConditionalWrapper";
import { UserAvatar } from "../UserAvatar";

import { Biography } from "./biography";

import type { ProfilePopupUserFragment } from "~/client/generated/schema";

type Props = Readonly<{
  user: ProfilePopupUserFragment;
}>;

const PopularNotes: React.FC<{ user: ProfilePopupUserFragment }> = ({ user }) => {
  if (!user.popularNotes.nodes || user.popularNotes.nodes.length === 0) {
    return null;
  }

  return (
    <div className="trendList">
      <h4 className="trendList-heading">
        <FormattedMessage id="profile.popularNotes" />
      </h4>
      <ol>
        {user.popularNotes.nodes.map((node, index) => {
          return (
            <li className="trendList-entry" key={node.id}>
              <span className="trendList-entry-index">{`${index + 1}.`}</span>
              <Link to={node.path}>
                <ExtendedText>{node.title}</ExtendedText>
              </Link>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

const CoverPhoto: React.FC<{ user: ProfilePopupUserFragment }> = ({ user }) => {
  if (user.coverImage) {
    return (
      <div className="panel-coverPhoto">
        <img className="userCoverImage" alt="" src={user.coverImage.url} />
      </div>
    );
  } else {
    return <div className="panel-coverPhoto is-empty" />;
  }
};

export const ProfilePopup: React.FC<Props> = (props) => {
  const user = props.user;

  return (
    <div className="profilePopup">
      <div className="panel memberPanel">
        <CoverPhoto user={user} />
        <div className="memberPanel-avatar">
          <UserAvatar user={user} additionalClass="profilePopup-avatar" size="large" />
        </div>
        <div className="panel-content memberPanel-content">
          <div className="panel-content-body">
            <div className={classNames("memberPanel-content-body-realName", !user.realName && "is-empty")}>
              <ConditionalWrapper
                condition={typeof user.path === "string"}
                node={(children) => <Link to={user.path!}>{children}</Link>}
              >
                {user.realName || <FormattedMessage id="profile.nouns.realNameEmpty" />}
              </ConditionalWrapper>
            </div>
            <div className="memberPanel-content-body-account">
              <ConditionalWrapper
                condition={typeof user.path === "string"}
                node={(children) => <Link to={user.path!}>{children}</Link>}
              >
                @{user.account}
              </ConditionalWrapper>
            </div>
            <div className="memberPanel-content-body-biography">
              <Biography bio={user.shortBio} />
            </div>
          </div>
          <div className="memberPanel-content-body-trendList">
            <PopularNotes user={user} />
          </div>
        </div>
      </div>
    </div>
  );
};
